import { getPatientRoute, getWorklistRoute } from "./zoneRoutes";
var STORAGE_KEY = "qure_viewer_return_path";
var RETURN_FAMILIES = ["/patients-v2", "/patients", "/worklist-v2", "/worklist"];
function matchReturnFamily(pathname) {
  return RETURN_FAMILIES.find(function (family) {
    return pathname === family || pathname.startsWith("".concat(family, "/"));
  });
}
function getSessionStorage() {
  try {
    return typeof window === "undefined" ? null : window.sessionStorage;
  } catch (_unused) {
    return null;
  }
}

/** True for any viewer route (/viewer/..., /viewer-v2/...). */
export function isViewerPath(pathname) {
  return pathname === "/viewer" || pathname.startsWith("/viewer/") || pathname.startsWith("/viewer-v2");
}

/**
 * Remembers the page the user opened the viewer from (path + query), or
 * forgets it when `path` is null. Stored per tab in sessionStorage so it
 * survives the full page load of a cross-zone (qtrack-lc) entry.
 */
export function rememberViewerReturnPath(path) {
  var storage = getSessionStorage();
  try {
    if (path) storage === null || storage === void 0 || storage.setItem(STORAGE_KEY, path);else storage === null || storage === void 0 || storage.removeItem(STORAGE_KEY);
  } catch (_unused2) {
    // storage unavailable (private mode / blocked) — back falls back to defaults
  }
}

/** Reads the remembered viewer entry page, if any. */
export function readViewerReturnPath() {
  try {
    var _getSessionStorage$ge, _getSessionStorage;
    return (_getSessionStorage$ge = (_getSessionStorage = getSessionStorage()) === null || _getSessionStorage === void 0 ? void 0 : _getSessionStorage.getItem(STORAGE_KEY)) !== null && _getSessionStorage$ge !== void 0 ? _getSessionStorage$ge : null;
  } catch (_unused3) {
    return null;
  }
}

/**
 * The same-origin, non-viewer page in document.referrer (path + query), or
 * null. This is how a viewer opened by a full page load — e.g. from
 * qtrack-lc's worklist, which is another zone on the same origin — learns
 * where the user came from.
 */
export function getReferrerReturnPath(referrer, origin) {
  if (!referrer) return null;
  try {
    var url = new URL(referrer);
    if (url.origin !== origin || isViewerPath(url.pathname)) return null;
    return "".concat(url.pathname).concat(url.search);
  } catch (_unused4) {
    return null;
  }
}

/**
 * Where the viewer's back action should go, given the remembered entry page.
 * Only patient/worklist pages qualify. `sameZone` says whether this app
 * serves that page under the current variant (router navigation is safe) or
 * qtrack-lc does (a full page load is required).
 */
export function resolveViewerBackTarget(returnPath) {
  if (!returnPath) return null;
  var family = matchReturnFamily(returnPath.split("?")[0]);
  if (!family) return null;
  var sameZone = family === getPatientRoute() || family === getWorklistRoute();
  return {
    url: returnPath,
    sameZone: sameZone
  };
}

/**
 * Whether a full page load straight into the viewer should take its return
 * path from document.referrer. Only a fresh navigation qualifies: on a
 * reload (manual, or the idle-timer reload) or browser back/forward,
 * document.referrer still names the page that first loaded the app, so the
 * value already remembered in sessionStorage is the correct one to keep.
 */
export function shouldUseReferrerReturnPath(navigationType) {
  return navigationType !== "reload" && navigationType !== "back_forward";
}